import { useQuery } from '@tanstack/react-query';
import { adminDashboardService } from '../api/adminDashboardService';

export const useAdminStatsQuery = () => {
    return useQuery({
        queryKey: ['admin-dashboard-stats'],
        queryFn: adminDashboardService.getStats
    });
};

export const useAdminChartsQuery = (period) => {
    return useQuery({
        queryKey: ['admin-dashboard-charts', period],
        queryFn: () => adminDashboardService.getCharts(period)
    });
};

export const useAdminRecentQuery = () => {
    return useQuery({
        queryKey: ['admin-dashboard-recent-orders'],
        queryFn: adminDashboardService.getRecentOrders
    });
};

export const useAdminTopVendorsQuery = () => {
    return useQuery({
        queryKey: ['admin-dashboard-top-vendors'],
        queryFn: adminDashboardService.getTopVendors
    });
};

export const useAdminVendorApplicationsQuery = () => {
    return useQuery({
        queryKey: ['admin-dashboard-vendor-applications'],
        queryFn: adminDashboardService.getVendorApplications
    });
};
